module.exports = __webpack_public_path__ + "img/default.c1966dde.png";